export enum EXCEL_TYPE {
  KOL_GENRE,
  KOL_CATEGORY,
}
